import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SlideShow.css';
import './common.css';
import Right from '../right.svg';
import Left from '../left.svg';

const delay = 4000;

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? "100%" : "-100%",
    opacity: 1,
  }),
  center: {
    x: "0%",
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction > 0 ? "-100%" : "100%",
    opacity: 1,
  }),
};

function SlideShow({ fadeImages }) {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [hoveredArrow, setHoveredArrow] = useState(false);
  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setDirection(1);
      setIndex((prevIndex) => (prevIndex === fadeImages.length - 1 ? 0 : prevIndex + 1));
    }, delay);

    return () => resetTimeout();
  }, [index]);

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prevIndex) => (prevIndex === 0 ? fadeImages.length - 1 : prevIndex - 1));
  };

  const nextSlide = () => {
    setDirection(1);
    setIndex((prevIndex) => (prevIndex === fadeImages.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="slideshow w-full">
      <div className="slideshowSlider overflow-hidden relative">
        <AnimatePresence initial={false} custom={direction} mode="wait">
          <motion.img
            key={index}
            className="slide_custom absolute w-full h-full"
            src={fadeImages[index].url}
            alt={fadeImages[index].caption}
            variants={variants}
            custom={direction}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.8, ease: "easeIn" }}
            onMouseEnter={() => setHoveredArrow( true)}
            onMouseLeave={() => setHoveredArrow(false)}
          />
        </AnimatePresence>
        <motion.div
          className="absolute custom-letter-spacing inset-0 flex items-center justify-center text-white text-4xl bg-opacity-50 text-center"
          initial={{ x: '-100%', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeIn" }}
        >
          VIBE DEVELOPER & GENERAL CONTRACTOR
        </motion.div>
        <div className="caption-bar absolute bottom-0 left-0 w-full p-4 text-white bg-neutral-900 bg-opacity-50 flex justify-between">
          <span className="slide-caption">{fadeImages[index].caption}</span>
          <span className="slide-index">{index + 1}/{fadeImages.length}</span>
        </div>
      </div>

      <button className={`prev-arrow ${hoveredArrow ? "visible" : "hidden"}`} onClick={prevSlide}>
        <img src={Left} alt="Left" className="h-8 w-8" />
      </button>
      <button className={`next-arrow ${hoveredArrow ? "visible" : "hidden"}`} onClick={nextSlide}>
        <img src={Right} alt="Right" className="h-8 w-8" />
      </button>
    </div>
  );
}

export default SlideShow;
